// extracted by mini-css-extract-plugin
module.exports = {"viewCountContainer":"ViewCount_viewCountContainer__l0O4i","viewCountBox":"ViewCount_viewCountBox__i5fcI"};